import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ClothingErrorService } from '../../../services/clothing-error.service';
import { ToastService } from '../../../services/toast.service';

@Injectable()
export class ViewUserProfileFeedbackService {
  constructor(
    private toastService: ToastService,
    private translate: TranslateService,
    private clothingErrorService: ClothingErrorService
  ) {}

  text(key: string, parameters?: Object): string {
    return this.translate.instant(key, parameters);
  }

  success(key: string): void {
    this.toastService.success(this.text(key));
  }

  error(key: string): void {
    this.toastService.error(this.text(key));
  }

  clothingError(error: HttpErrorResponse, fallbackKey: string): void {
    this.toastService.error(this.clothingErrorService.resolveMessage(error, fallbackKey));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile-feedback.service.ts